import React, { useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import "./confirm.styles.css";
import { useConfirmContext } from "../../Providers";
function Confirm({data}) {
    const [alert, setAlert] = React.useState(null);
    const {confirmDispatch} = useConfirmContext();

    const execute = (process) => {
        process();
        setAlert(null);
    };
    
    const beforeMount = () => {
        
    }
    useEffect(() => {
        if (data.some((x) => x)) {
            var {
                alertType,
                title,
                textBody,
                onConfirm,
                onCancel,
                confirmBtnBsStyle = "success",
                cancelBtnBsStyle = "danger",
                confirmBtnText = data.confirmBtnText ?? "Confirmar",
                cancelBtnText = data.cancelBtnText ?? "Cancelar",
                showCancel = true,
                closeOnClickOutside,
                style = {display: "block"},
            } = data[0].content;

            setAlert(
                <SweetAlert
                    customClass="customRowStyle"
                    type={alertType}
                    style={style}
                    title={title}
                    onConfirm={() => execute(onConfirm)}
                    onCancel={() => execute(onCancel)}
                    closeOnClickOutside={closeOnClickOutside}
                    confirmBtnBsStyle={confirmBtnBsStyle}
                    cancelBtnBsStyle={cancelBtnBsStyle}
                    confirmBtnText={confirmBtnText}
                    cancelBtnText={cancelBtnText}
                    showCancel={showCancel}
                    confirmBtnCssClass="btn btn-sm customBtnConfirm"
                    cancelBtnCssClass="btn btn-sm customBtnCancel"
                    beforeMount={beforeMount}
                    afterUpdate={beforeMount}
                >
                    {textBody}
                </SweetAlert>
            );
            return confirmDispatch({type: "REMOVE_ALL"});
        }
    });

    return <><div className='bootstrapiso'>{alert}</div></>;
}
export default Confirm;
